<template>
<div class="sa-card sa-card-noshadow sa-patient-profile">
    <div class="sa-card-list-box">
        <figure class="sa-avtar-sm">
            <img :src="familyList.img || imgUrl" alt="Doctor" class="sa-img-cover sa-av-img">
        </figure>
        <div class="sa-doct-det">
            <h6 class="sa-app-size10">{{familyList.name}}
                <span class="sa-patient-pro sa-app-size10">
                    <strong class="sa-f-size12">{{familyList.appointments.count}} - </strong>
                    <span class="sa-app-size8">{{familyList.appointments.label}}</span>
                </span>
            </h6>
        </div>
    </div>
    <span class="sa-marker" :style="{'background-color': familyList.package.color, 'color': familyList.package.text}">{{familyList.package.label}}</span>
    <hr class="sa-hr">
    <div class="sa-patient-pro-det">
        <span :style="{'color': familyList.booking.color}">{{familyList.booking.status}}</span>
        <span>{{familyList.booking.time}}</span>
    </div>
    <family-patients-members :familyList="familyList" class="sa-fam-patients"/>
</div>
</template>

<script>
import FamilyPatientsMembers from '../../components/familydoctors/FamilyPatientsMembers.vue'
export default {
    props: ['familyList'],
    components: {
        FamilyPatientsMembers
    },
    data() {
        return {
            imgUrl: 'https://img.litedev.com/images/unknown-avtar.png'
        }
    },
}
</script>

<style scoped>

.sa-booking-status {
    line-height: 12px;
}

.sa-booking-status span {
    font-size: 10px;
}

</style>
